"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersCreate = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const button_1 = require("client/components/material/button");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const select_1 = require("client/components/material/select");
const switch_1 = require("client/components/material/switch");
const text_field_1 = require("client/components/material/text-field");
const time_picker_1 = require("client/components/material/timepicker/time-picker");
const floating_page_1 = require("client/components/page/floating-page");
const router_1 = require("client/components/router");
const ui_1 = require("client/components/ui");
const alert_1 = require("client/components/ui/alert");
const multi_select_1 = require("client/components/ui/multi-select");
const store_1 = require("client/modules/inventory/modules/inventory-list/store");
const store_2 = require("client/modules/patients/store");
const store_3 = require("client/modules/sites/modules/sites-list/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment-timezone");
const React = require("react");
const react_1 = require("react");
const ReactTooltip = require("react-tooltip");
const order_1 = require("shared/order");
const util_1 = require("shared/util");
const throttle_debounce_1 = require("throttle-debounce");
const store_4 = require("../../../sites/modules/sites-detail/store");
const store_5 = require("../../../users/store");
const store_6 = require("../../store");
require("./orders-create.less");
const core_1 = require("@material-ui/core");
const store_7 = require("client/modules/providers/store"); // C-095.3
const paymentOptions = [
    {
        id: 1,
        label: "Cash",
        value: "1"
    },
    {
        id: 2,
        label: "Insurance",
        value: "2"
    }
];
let OrdersCreate = class OrdersCreate extends react_1.Component {
    constructor() {
        super(...arguments);
        this.cash = true;
        this.inventory = [];
        this.runDate = moment();
        this.runTime = moment();
        this.showUpload = false;
        this.siteId = null;
        this.status = ui_1.FormStatus.Clean;
        this.showSites = true;
        this.manualOverride = false;
        this.showConfirmation = false;
        this.selectedPaymentOption = "";
        // public insuranceCards: any[]; // Not sure about type; see bottom of page.
        this.selectedCard = "";
        this.displayedInventory = [];
        this.displayedGroups = [];
        this.bypassAutomation = false;
        this.disableSubmit = false;
        this.altInsurances = false;
        this.showQuantities = false;
        this.isPICExpired = false; // C-095.2
        this.deaExpItemDate = null; // C-095.2
        this.stateLicenseExpItemDate = null; // C-095.2
        this.getStatus = null; // C-095.2
        this.loadInventories = throttle_debounce_1.debounce(200, (value) => {
            if (this.siteId) {
                store_4.sitesDetailStore.loadInventories(this.siteId, value);
            }
        });
        this.handleSearch = (value, type) => {
            const isInventory = type === "inventory";
            const origin = isInventory ? this.availableInventory : this.availableGroups;
            return origin.filter((item) => item.label.toLowerCase().includes(value));
        };
        this.onMouseEnter = () => {
            this.showUpload = true;
        };
        this.onMouseLeave = () => {
            this.showUpload = false;
        };
        this.handleChange = (field) => async (id) => {
            var _a, _b;
            // C-095.3 
            let arr = ['MD', 'DO', 'APRN', 'DPM'];
            this[field] = Number(id);
            if (field === "patientId") {
                const completePatient = await store_2.patientsStore.readPatient(Number(id));
                this.currentPatient = completePatient;
                if (this.currentPatient.insurances &&
                    this.currentPatient.insurances.length > 0) {
                    await this.getInsuranceCards();
                    if (this.insuranceCards && this.insuranceCards.length) {
                        this.selectedCard = this.insuranceCards[0].value;
                        this.selectedPaymentOption = "2";
                        this.cash = false;
                    }
                }
                else {
                    this.selectedCard = "";
                    this.selectedPaymentOption = "1";
                    this.cash = true;
                }
            }
            else if (field === 'providerId') {
                if (id !== null) {
                    this.providerId = id;
                    await store_7.providersStore.readProvider(Number(id));
                }
                if (!arr.includes((_b = (_a = store_7.providersStore.provider) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.title)) {
                    this.checkIsPICexpired(); // C-095.2
                }
            }
        };
        // C-095.2
        this.checkIsPICexpired = async () => {
            var _a, _b;
            let picId = this.siteHasPic;
            await ((_b = (_a = store_4.sitesDetailStore === null || store_4.sitesDetailStore === void 0 ? void 0 : store_4.sitesDetailStore.providers) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.map((provider, i) => {
                if (provider.id == picId) {
                    const today = moment().format('YYYY-MM-DD');
                    let stateLicenseExpItem = moment(provider === null || provider === void 0 ? void 0 : provider.stateLicenseExp).format('YYYY-MM-DD');
                    let deaExpItem = moment(provider === null || provider === void 0 ? void 0 : provider.deaExp).format('YYYY-MM-DD');
                    if (stateLicenseExpItem === "Invalid date") {
                        this.stateLicenseExpItemDate = "";
                    }
                    else {
                        if (moment(stateLicenseExpItem).isSameOrAfter(today) === false) {
                            this.stateLicenseExpItemDate = "State License";
                        }
                        else if (moment(stateLicenseExpItem).isSameOrAfter(today) === true) {
                            this.stateLicenseExpItemDate = "";
                        }
                    }
                    if (deaExpItem === "Invalid date") {
                        this.deaExpItemDate = "";
                    }
                    else {
                        if (moment(deaExpItem).isSameOrAfter(today) === false) {
                            this.deaExpItemDate = "DEA License";
                        }
                        else if (moment(deaExpItem).isSameOrAfter(today) === true) {
                            this.deaExpItemDate = "";
                        }
                    }
                    if (this.stateLicenseExpItemDate.length && this.deaExpItemDate.length) {
                        this.getStatus = provider.firstName + "  " + provider.lastName + " - " + this.stateLicenseExpItemDate + " & " + this.deaExpItemDate + " Expired";
                    }
                    else if (this.stateLicenseExpItemDate.length) {
                        this.getStatus = provider.firstName + "  " + provider.lastName + " - " + this.stateLicenseExpItemDate + " Expired";
                    }
                    else if (this.deaExpItemDate.length) {
                        this.getStatus = provider.firstName + "  " + provider.lastName + " - " + this.deaExpItemDate + " Expired";
                    }
                    if (moment(stateLicenseExpItem).isSameOrAfter(today) && moment(deaExpItem).isSameOrAfter(today)) {
                        this.isPICExpired = false;
                    }
                    else {
                        this.isPICExpired = true;
                    }
                }
            }));
        };
        this.handleChangeSite = (id) => {
            this.siteId = Number(id);
            this.inventory = [];
            store_4.sitesDetailStore.loadProviders({
                id: this.siteId,
                order: "ASC"
            });
            store_4.sitesDetailStore.loadPatients({
                id: this.siteId,
                order: "ASC"
            });
            store_4.sitesDetailStore.loadInventories(this.siteId);
        };
        this.handleCancel = () => {
            router_1.RouteManager.transitionTo(`/claims`);
        };
        this.handleClickCash = () => {
            this.cash = !this.cash;
        };
        this.handleChangeDate = (value) => {
            this.runDate = value;
        };
        this.handleChangeTime = (value) => {
            this.runTime = value;
        };
        this.handleSubmit = async () => {
            this.disableSubmit = true;
            if (!this.siteId)
                return;
            const orderType = this.cash ? order_1.OrderType.Cash : order_1.OrderType.Default;
            const runAt = moment(`${this.runDate.format("MM/DD/YYYY")} ${this.runTime.format("hh:mm a")}`).format();
            const groups = this.inventory.map(group => group.value);
            const inventory = this.manualOverride
                ? this.showQuantities
                    ? this.inventory.map(i => ({
                        daysSupply: i.daysSupply,
                        id: Number(i.value),
                        quantity: i.quantity
                    }))
                    : this.inventory.map(i => Number(i.value))
                : store_4.sitesDetailStore.inventorysites.value
                    .filter((ndc) => groups.includes(ndc.inventory.group))
                    .map(ndc => ndc.inventoryId);
            const insurance = this.currentPatient.insurances.find((ins) => ins.insuranceId === this.selectedCard && !ins.deletedAt);
            const altInsurances = this.altInsurances ? { ids: [1] } : null;
            const response = await store_6.ordersStore.createOrder(this.siteId, this.providerId, this.patientId, insurance ? insurance.id : null, inventory, orderType, runAt, this.bypassAutomation, altInsurances);
            if (response === null || response === void 0 ? void 0 : response.order) {
                router_1.RouteManager.transitionTo(`/claims/${response.order.id}`);
            }
            this.disableSubmit = false;
        };
        this.isChanged = () => {
            if (!this.siteId)
                return false;
            if (!this.patientId)
                return false;
            if (!this.providerId)
                return false;
            return true;
        };
        this.handlePaymentOptionSelect = (value) => {
            // value references the values in the in the paymentOptions Variable above
            if (value === "1") {
                this.cash = true;
                this.selectedPaymentOption = paymentOptions.find(option => option.label === "Cash").value;
                this.selectedCard = ""; // Reset selectedCard
            }
            else if (value === "2") {
                this.cash = false;
                this.selectedPaymentOption = paymentOptions.find(option => option.label === "Insurance").value;
                this.getInsuranceCards();
                // @tkay
                if (this.insuranceCards && this.insuranceCards.length) {
                    this.selectedCard = this.insuranceCards[0].value;
                }
            }
        };
        this.getInsuranceCards = async () => {
            const insuranceCards = this.currentPatient.insurances.filter((card) => !card.deletedAt && !card.copay);
            const paymentOptions = insuranceCards.map((card, i) => {
                const option = {
                    id: i,
                    label: card.insuranceId,
                    value: card.insuranceId
                };
                return option;
            });
            this.insuranceCards = paymentOptions;
        };
    }
    get availableOptions() {
        return store_3.sitesListStore.sites.value
            ? store_3.sitesListStore.sites.value.map((site, i) => ({
                id: i,
                label: site.displayName || site.name,
                value: site.id.toString()
            }))
            : [];
    }
    get siteHasPic() {
        const selectedSite = store_3.sitesListStore.sites.value.find(site => site.id === this.siteId);
        return selectedSite === null || selectedSite === void 0 ? void 0 : selectedSite.picProviderId;
    }
    get availableProviders() {
        return store_4.sitesDetailStore.providers.value
            ? store_4.sitesDetailStore.providers.value
                .filter(provider => {
                const isUnavailable = provider.sitesAbsent.find(site => String(site.id) === String(this.siteId));
                return !isUnavailable;
            })
                .map((provider, i) => {
                const today = moment().startOf("day");
                const isExpired = moment(today).isSameOrAfter(provider.deaExp) ||
                    moment(today).isSameOrAfter(provider.stateLicenseExp);
                if (isExpired) {
                    return {
                        disabled: true,
                        id: i,
                        label: `${provider.prefix} ${provider.firstName} ${provider.lastName} ${provider.suffix} (DEA/License Expired)`,
                        value: provider.id.toString()
                    };
                }
                return {
                    id: i,
                    label: `${provider.prefix} ${provider.firstName} ${provider.lastName} ${provider.suffix}`,
                    value: provider.id.toString()
                };
            })
            : [];
    }
    get availablePatients() {
        return store_4.sitesDetailStore.patients.value
            ? store_4.sitesDetailStore.patients.value.map((patient, i) => {
                const dob = patient.birthDate === "0000-00-00" ? "N/A" : patient.birthDate;
                return {
                    id: i,
                    label: `${patient.firstName} ${patient.lastName} (${dob || "N/A"})`,
                    value: patient.id.toString()
                };
            })
            : [];
    }
    get availableInventory() {
        // console.log("inv: ", toJS(sitesDetailStore.inventorysites));
        return store_4.sitesDetailStore.inventorysites.value
            ? store_4.sitesDetailStore.inventorysites.value.map((ndc, i) => ({
                daysSupply: ndc.inventory.daysSupply,
                group: ndc.inventory.inventoryGroupId,
                id: ndc.inventory.id,
                label: `${ndc.inventory.name} (${ndc.inventory.package})`,
                quantity: !!ndc.claimQuantity
                    ? ndc.claimQuantity
                    : ndc.inventory.claimQuantity,
                value: ndc.inventory.id.toString()
            }))
            : [];
    }
    get availableGroups() {
        const inventory = store_4.sitesDetailStore.inventorysites.value;
        const siteGroups = inventory === null || inventory === void 0 ? void 0 : inventory.map((site) => site.inventory.group.toUpperCase());
        if (!siteGroups)
            return; // Bypass empty setting loads.
        const allGroups = store_1.inventoryListStore.inventoryGroups.value
            ? store_1.inventoryListStore.inventoryGroups.value.map((group) => ({
                id: group.id,
                label: group.group.toUpperCase(),
                value: group.group
            }))
            : [];
        // Even admins can't run items not in a pharmacy, so filter them for display.
        return allGroups.filter((group) => {
            if (siteGroups.includes(group.label))
                return group;
        });
    }
    componentWillMount() {
        if (!store_5.usersStore.permissions.ReadPharmacies) {
            this.showSites = false;
            this.siteId = store_5.usersStore.user.value.siteId;
            // console.log("WERE IN HERE");
            this.handleChangeSite(String(this.siteId));
        }
        else {
            store_3.sitesListStore.loadSitesNoRelation();
            if (this.props.params[0]) {
                this.siteId = Number(this.props.params[0]);
                store_4.sitesDetailStore.loadPatients({ id: this.siteId });
            }
        }
        store_1.inventoryListStore.loadInventoryGroup();
    }
    componentWillUnmount() {
        store_6.ordersStore.order.error = undefined;
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    renderForm() {
        var _a;
        return (React.createElement("div", null,
            React.createElement("div", { className: "main" },
                React.createElement("h3", null, "Provider"),
                React.createElement("div", { className: "inputs" },
                    React.createElement("div", { className: "row" },
                        React.createElement(select_1.MaterialSelect, { options: this.availableProviders, required: true, searchable: true, label: "Provider", onSelect: this.handleChange("providerId"), value: String(this.providerId) || "" })))),
            this.isPICExpired &&
                React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Update license" //C-095.1
                    , cancelText: "Cancel", message: `<strong style="color:red;"> ${this.getStatus} </strong>`, onCancel: () => {
                        this.isPICExpired = false;
                        String(this.providerId = "");
                    }, onConfirm: () => { router_1.RouteManager.transitionTo(`/pharmacies/${this.siteId}/providers/${this.siteHasPic}`); }, title: "PIC Update Required" // C-095.1
                 }),
            React.createElement("div", { className: "main" },
                React.createElement("h3", null, "Patient"),
                React.createElement("div", { className: "inputs" },
                    React.createElement("div", { className: "row" },
                        React.createElement(select_1.MaterialSelect, { options: this.availablePatients, required: true, searchable: true, label: "Patient", onInputChange: e => {
                                if (!this.patientId || (this.patientId && e.length > 0)) {
                                    store_4.sitesDetailStore.loadPatients({
                                        id: this.siteId,
                                        search: e || ""
                                    });
                                }
                            }, onSelect: this.handleChange("patientId"), value: String(this.patientId) || "", disabled: ((_a = this.providerId) === null || _a === void 0 ? void 0 : _a.length) ? false : true })))),
            React.createElement("div", { className: "main" },
                React.createElement("h3", null, "Run at"),
                React.createElement("div", { className: "inputs" },
                    React.createElement("div", { className: "row" },
                        React.createElement(date_picker_1.MaterialDatePicker, { label: "Run Date", className: "expire-date", onChange: this.handleChangeDate, value: this.runDate }),
                        React.createElement(time_picker_1.MaterialTimePicker, { value: this.runTime, label: "Run Time", onChange: this.handleChangeTime })))),
            React.createElement("div", { className: "main" },
                React.createElement("h3", null, "Formulary"),
                React.createElement("div", { className: "inputs" },
                    React.createElement("div", { className: "row" },
                        React.createElement("p", { className: "warning" },
                            "Active Selection:",
                            " ",
                            React.createElement("b", null, this.inventory.length > 0
                                ? this.manualOverride
                                    ? "Selected Drugs"
                                    : "Selected Groups"
                                : "Full Formulary"))),
                    React.createElement("ul", null,
                        React.createElement("li", null, "Leave blank to submit full pharmacy formulary."),
                        React.createElement("li", null, "Add groups to submit only selected groups."),
                        React.createElement("li", null, "Add manual inventory to submit only selected drugs.")),
                    (this.manualOverride && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "row" },
                            React.createElement(multi_select_1.UiMultiSelect, { className: "short-class", label: "Mode: Add by Drug", options: (this.displayedInventory.length &&
                                    this.displayedInventory) ||
                                    this.availableInventory, values: this.inventory, onChange: (values) => {
                                    this.inventory = values;
                                    if (!this.inventory.length)
                                        this.showQuantities = false;
                                }, onSearch: e => (this.displayedInventory = this.handleSearch(e, "inventory")) }),
                            React.createElement("div", { style: { display: "block" } },
                                React.createElement(button_1.MaterialButton, { onClick: () => {
                                        this.manualOverride = false;
                                        this.inventory = [];
                                    }, secondary: true }, "Use Groups"),
                                !!this.inventory.length &&
                                    store_5.usersStore.permissions.ReadQuantity ? (React.createElement(switch_1.MaterialSwitch, { checked: this.showQuantities, onChange: () => {
                                        this.showQuantities = !this.showQuantities;
                                    }, label: "Modify Quantities", value: "qty" })) : (""))),
                        this.showQuantities && store_5.usersStore.permissions.ReadQuantity ? (React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "row-alternating-colors", style: { display: "block" } },
                                React.createElement("p", null,
                                    React.createElement("i", null, "Enter comma-separated values (ex. \"5,3,1\").")),
                                this.inventory.map((inv) => (React.createElement("div", { style: {
                                        alignItems: "center",
                                        border: "solid 1px #f7f7f7",
                                        display: "flex",
                                        justifyContent: "space-between"
                                    } },
                                    React.createElement(core_1.Typography, null, inv.label),
                                    React.createElement("div", null,
                                        React.createElement(text_field_1.MaterialTextField, { label: "Quantity", value: inv.quantity, onChange: (e, v) => {
                                                if (!!v.match(/[^\d,]/g))
                                                    return;
                                                inv.quantity = v;
                                            } }),
                                        React.createElement(text_field_1.MaterialTextField, { label: "Days Supply", value: inv.daysSupply, onChange: (e, v) => {
                                                if (!!v.match(/[^\d]/g))
                                                    return;
                                                inv.daysSupply = v;
                                            } })))))))) : ("")))) || (React.createElement("div", { className: "row" },
                        React.createElement(multi_select_1.UiMultiSelect, { className: "short-class", label: "Mode: Add by Group", options: (this.displayedGroups.length && this.displayedGroups) ||
                                this.availableGroups, values: this.inventory, onChange: (values) => {
                                this.inventory = values;
                            }, onSearch: e => (this.displayedGroups = this.handleSearch(e, "groups")) }),
                        React.createElement(button_1.MaterialButton, { onClick: () => {
                                this.manualOverride = true;
                                this.inventory = [];
                            }, secondary: true }, "Manual Input"))))),
            // else we will get Error
            this.currentPatient ? (this.currentPatient.missingInsurance ? (React.createElement("div", null,
                React.createElement(alert_1.UiAlert, { title: "Warning", type: "warning", message: "Payment Method defaults to Cash unless the Patient has Insurance." }))) : null) : null,
            this.currentPatient ? (React.createElement("div", { className: "main" },
                React.createElement("h3", null, "Payment Method"),
                React.createElement("div", { className: "inputs" },
                    React.createElement("div", { className: "row" },
                        this.currentPatient.insuranceId ? ( // It exists because of the patient read endpoint.
                        React.createElement(React.Fragment, null,
                            React.createElement(select_1.MaterialSelect, { label: "Payment Option", options: paymentOptions, required: true, onSelect: e => this.handlePaymentOptionSelect(e), value: this.selectedPaymentOption || "1" }),
                            this.selectedPaymentOption === "2" &&
                                this.currentPatient.insurances.length > 0 && (React.createElement(React.Fragment, null,
                                React.createElement(select_1.MaterialSelect, { label: "Insurance Card", options: this.insuranceCards, required: true, onSelect: e => (this.selectedCard = e), value: this.selectedCard || this.insuranceCards[0].value }),
                                React.createElement(checkbox_1.MaterialCheckbox, { id: "runall", type: "checkbox", style: { minWidth: "fitContent" }, label: "Run All", onAction: () => (this.altInsurances = !this.altInsurances), checked: this.altInsurances }))))) : ("Cash"),
                        React.createElement("div", { className: "view-patient" },
                            React.createElement("a", { href: `/patients/${this.currentPatient.id}` }, "Edit Patient"))),
                    store_5.usersStore.permissions.ReadBypass && (React.createElement("div", { className: "row" },
                        React.createElement(checkbox_1.MaterialCheckbox, { label: "Bypass Claim Automation Tree", checked: this.bypassAutomation, onAction: () => (this.bypassAutomation = !this.bypassAutomation) })))))) : null));
    }
    render() {
        const buttons = [
            React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"),
            "submit"
        ];
        // console.log(sitesDetailStore);
        return (React.createElement("div", { className: "claim-wrapper" }, store_5.usersStore.permissions.CreateClaims ? (React.createElement(React.Fragment, null,
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement(kpi_title_1.KpiTitle, { label: "Create Claim", subLabel: "" })),
            React.createElement(floating_page_1.FloatingPage, null,
                React.createElement("div", { className: "edit-order" },
                    React.createElement(ui_1.UiForm, { buttons: buttons, loading: this.props.loading, shouldDisableSave: this.disableSubmit, status: this.status, saved: "Submitted", onSubmit: this.handleSubmit, 
                        // onSubmit={() => this.showConfirmation = true}
                        isChanged: this.isChanged, error: store_6.ordersStore.order.error },
                        React.createElement("div", { className: "practice" },
                            this.showSites && (React.createElement("div", { className: "main" },
                                React.createElement("h3", null, "Pharmacy"),
                                React.createElement("div", { className: "inputs" },
                                    React.createElement("div", { className: "row" },
                                        React.createElement(select_1.MaterialSelect, { options: this.availableOptions, required: true, searchable: true, label: "Pharmacy", onSelect: this.handleChangeSite, onInputChange: e => {
                                                util_1.pharmacyDropDownHandler({
                                                    id: Number(this.siteId),
                                                    search: e
                                                });
                                            }, value: String(this.siteId) || "" })),
                                    this.siteId && !this.siteHasPic ? (React.createElement("div", { className: "row" },
                                        React.createElement("p", { style: { marginTop: 0 } },
                                            "Pharmacies ",
                                            React.createElement("b", null, "must"),
                                            " have a provider in charge.",
                                            React.createElement("br", null),
                                            store_5.usersStore.permissions.UpdatePharmacy && (React.createElement("span", null,
                                                React.createElement("a", { className: "pharmLink", onClick: () => router_1.RouteManager.transitionTo(`/pharmacies/${this.siteId}`) }, "Click here"),
                                                " ",
                                                "to modify the pharmacy's settings."))))) : // <div className="row">
                                        //   <Typography>
                                        //     No provider in charge detected. Cannot create
                                        //     order claim.
                                        //     <br />
                                        //     <Link to={`/pharmacies/${this.siteId}`}>
                                        //       Click here to assign a provider in charge.
                                        //     </Link>
                                        //   </Typography>
                                        // </div>
                                        null))),
                            this.siteId && this.siteHasPic ? this.renderForm() : null)))),
            this.showConfirmation && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Submit", cancelText: "Cancel", message: "Please confirm claim submission to proceed.", onCancel: () => (this.showConfirmation = false), onConfirm: this.handleSubmit, title: "Submission Confirmation" })))) : (store_5.usersStore.showLock())));
    }
};
__decorate([
    mobx_1.computed
], OrdersCreate.prototype, "availableOptions", null);
__decorate([
    mobx_1.computed
], OrdersCreate.prototype, "siteHasPic", null);
__decorate([
    mobx_1.computed
], OrdersCreate.prototype, "availableProviders", null);
__decorate([
    mobx_1.computed
], OrdersCreate.prototype, "availablePatients", null);
__decorate([
    mobx_1.computed
], OrdersCreate.prototype, "availableInventory", null);
__decorate([
    mobx_1.computed
], OrdersCreate.prototype, "availableGroups", null);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "cash", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "inventory", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "patientId", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "currentPatient", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "providerId", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "runDate", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "runTime", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "showUpload", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "status", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "showSites", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "manualOverride", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "showConfirmation", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "selectedPaymentOption", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "insuranceCards", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "selectedCard", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "displayedInventory", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "displayedGroups", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "bypassAutomation", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "disableSubmit", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "altInsurances", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "showQuantities", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "isPICExpired", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "deaExpItemDate", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "stateLicenseExpItemDate", void 0);
__decorate([
    mobx_1.observable
], OrdersCreate.prototype, "getStatus", void 0);
OrdersCreate = __decorate([
    mobx_react_1.observer
], OrdersCreate);
exports.OrdersCreate = OrdersCreate;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-create/orders-create.tsx
// module id = 3739
// module chunks = 0